import { OrderStatus } from "../types/order";

/** Left-border accent for report order cards, matching status chip colors. */
export const getOrderStatusAccentColor = (status: OrderStatus | string): string => {
  switch (status) {
    case OrderStatus.IN_REVIEW:
      return "#F59E0B";
    case OrderStatus.REVISION_REQUIRED:
      return "#EF4444";
    case OrderStatus.VERIFIED:
      return "#3B82F6";
    case OrderStatus.APPROVED:
    case OrderStatus.APPROVED_WITH_OVERRIDE:
    case OrderStatus.COMPLETED:
      return "#22C55E";
    default:
      return "#94A3B8";
  }
};
